import { TripProviderTypes } from '../../lib/types/models/trip-provider/trip-provider'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripProvider(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripProviders.get.url, { id }))
    .get<TripProviderTypes.Full>()
}
